export default __webpack_public_path__ + "static/popup-mobile-7f111dc3ba017600988a88e8a2230e8e.webp";